<template>
  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
            <div class="flex items-center justify-between con-btns-user">
              <div class="flex items-center justify-start con-userx">
                <span class="font-semibold text-primary">
                  {{rm_details.company_product_code ? rm_details.category.prefix + '-' +rm_details.company_product_code : ''}}
                </span>

                <vs-chip size="small" class="ml-2" transparent color="#7952B3">
                  {{ rm_details.supplier_product_code ? rm_details.supplier_product_code : rm_details.supplier_product_name }}
                </vs-chip>

              </div>
              <div class="flex">

              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-tabs v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
      <!-- GENERAL -->
      <vs-tab :disabled="false" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-home v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Raw Material Product Identity' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-employee v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Physical, Chemical and Sensory parameters' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-site-details v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Manufacturing Process' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-manufacturing-process v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-check" :label="!isSmallerScreen ? 'Product Authenticity' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-product-authenticity v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-shield-off" :label="!isSmallerScreen ? 'Composition' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-composition v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Additives Preservatives' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-additives-preservatives v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Solvents' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-solvents v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Enzymes & Catalysts' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-enzymes-catalysts v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Genetically Modified Organisms' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-genetically-modified-organisms v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Allergens' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-allergens v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Biologically Active Principles (BAPs)' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-biologically-active-principles v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Palm Oil and Derivatives' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-palm-oil-derivatives v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Additional information' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-additional-information v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Storage & shelf-life' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-storage-shelf-life v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Packaging & Transport' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-packaging-transport v-on:notify="notify($event)"/>
        </div>
      </vs-tab>


      <vs-tab icon-pack="feather" icon="icon-check" :label="!isSmallerScreen ? 'Dietary Suitability' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-dietary-suitability v-on:notify="notify($event)" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-check-square" :label="!isSmallerScreen ? 'Contaminants and Pesticides' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-contaminants-pesticides v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Product Treatments' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-product-treatments v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Legislative Status' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-legislative-status v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Global Suitability' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-global-suitability  v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Supporting Documentation' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-supporting-documentation v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Commercial Details' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-commercial-details v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-button v-if="status && status.status.id === 1 && $can('edit-raw-material')" @click="onClickSubmitRawMaterial" button="submit" color="primary" type="filled" size="medium" class="mt-12 mb-8 mr-0 float-right">Submit raw material</vs-button>
      <!--    <vs-tab icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Transport & Storage' : ''">-->
      <!--      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">-->
      <!--        <supplier-manufacturing-transport v-on:notify="notify($event)"/>-->
      <!--      </div>-->
      <!--    </vs-tab>-->
      <!--    <vs-tab icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Health & Safety' : ''">-->
      <!--      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">-->
      <!--        <supplier-manufacturing-health-safety v-on:notify="notify($event)"/>-->
      <!--      </div>-->
      <!--    </vs-tab>-->
      <!--    <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Product Authenticity & Traceability' : ''">-->
      <!--      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">-->
      <!--        <supplier-manufacturing-authenticity/>-->
      <!--      </div>-->
      <!--    </vs-tab>-->
    </vs-tabs>
  </span>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const SupplierRepository = RepositoryFactory.get('supplier');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SupplierManufacturingHome from './SupplierManufacturingHome.vue'
  import SupplierManufacturingEmployee from './SupplierManufacturingEmployee.vue'
  import SupplierManufacturingSiteDetails from './SupplierManufacturingSiteDetails.vue'
  import SupplierManufacturingQuality from './SupplierManufacturingQuility.vue'
  import SupplierManufacturingEnvironment from './SupplierManufacturingEnvironment.vue'
  import SupplierManufacturingEthical from './SupplierManufacturingEthical.vue'
  import SupplierManufacturingAllergens from './SupplierManufacturingAllergens.vue'
  import SupplierManufacturingHaccp from './SupplierManufacturingHaccp.vue'
  import SupplierManufacturingPest from './SupplierManufacturingPest.vue'
  import SupplierManufacturingTransport from './SupplierManufacturingTransport.vue'
  import SupplierManufacturingHealthSafety from './SupplierManufacturingHealthSafety.vue'
  import SupplierManufacturingAuthenticity from './SupplierManufacturingAuthenticity.vue'
  import SupplierManufacturingHygiene from './SupplierManufacturingHygiene.vue'
  import SupplierRawMaterialManufacturingProcess from './SupplierRawMaterialManufacturingProcess.vue'
  import SupplierRawMaterialProductAuthenticity from './SupplierRawMaterialProductAuthenticity.vue'
  import SupplierRawMaterialComposition from './SupplierRawMaterialComposition.vue'
  import SupplierRawMaterialAdditivesPreservatives from './SupplierRawMaterialAdditivesPreservatives.vue'
  import SupplierRawMaterialSolvents from './SupplierRawMaterialSolvents.vue'
  import SupplierRawMaterialEnzymesCatalysts from './SupplierRawMaterialEnzymesCatalysts.vue'
  import SupplierRawMaterialGeneticallyModifiedOrganisms from './SupplierRawMaterialGeneticallyModifiedOrganisms.vue'
  import SupplierRawMaterialAllergens from './SupplierRawMaterialAllergens.vue'
  import SupplierRawMaterialBiologicallyActivePrinciples from './SupplierRawMaterialBiologicallyActivePrinciples.vue'
  import SupplierRawMaterialPalmOilDerivatives from './SupplierRawMaterialPalmOilDerivatives.vue'
  import SupplierRawMaterialAdditionalInformation from './SupplierRawMaterialAdditionalInformation.vue'
  import SupplierRawMaterialStorageShelfLife from './SupplierRawMaterialStorageShelfLife.vue'
  import SupplierRawMaterialPackagingTransport from './SupplierRawMaterialPackagingTransport.vue'
  import SupplierRawMaterialDietarySuitability from './SupplierRawMaterialDietarySuitability.vue'
  import SupplierRawMaterialProductTreatments from './SupplierRawMaterialProductTreatments.vue'
  import SupplierRawMaterialLegislativeStatus from './SupplierRawMaterialLegislativeStatus.vue'
  import SupplierRawMaterialGlobalSuitability from './SupplierRawMaterialGlobalSuitability.vue'
  import SupplierRawMaterialSupportingDocumentation from './SupplierRawMaterialSupportingDocumentation.vue'
  import SupplierRawMaterialContaminantsPesticides from './SupplierRawMaterialContaminantsPesticides.vue'
  import SupplierRawMaterialCommercialDetails from './SupplierRawMaterialCommercialDetails.vue'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    components: {
      SupplierManufacturingHome,
      SupplierManufacturingEmployee,
      SupplierManufacturingSiteDetails,
      SupplierManufacturingQuality,
      SupplierManufacturingEnvironment,
      SupplierManufacturingEthical,
      SupplierManufacturingAllergens,
      SupplierManufacturingHaccp,
      SupplierManufacturingPest,
      SupplierManufacturingTransport,
      SupplierManufacturingHealthSafety,
      SupplierManufacturingAuthenticity,
      SupplierManufacturingHygiene,

      SupplierRawMaterialManufacturingProcess,
      SupplierRawMaterialProductAuthenticity,
      SupplierRawMaterialComposition,
      SupplierRawMaterialAdditivesPreservatives,
      SupplierRawMaterialSolvents,
      SupplierRawMaterialEnzymesCatalysts,
      SupplierRawMaterialGeneticallyModifiedOrganisms,
      SupplierRawMaterialAllergens,
      SupplierRawMaterialBiologicallyActivePrinciples,
      SupplierRawMaterialPalmOilDerivatives,
      SupplierRawMaterialAdditionalInformation,
      SupplierRawMaterialStorageShelfLife,
      SupplierRawMaterialPackagingTransport,
      SupplierRawMaterialDietarySuitability,
      SupplierRawMaterialProductTreatments,
      SupplierRawMaterialLegislativeStatus,
      SupplierRawMaterialGlobalSuitability,
      SupplierRawMaterialSupportingDocumentation,
      SupplierRawMaterialContaminantsPesticides,
      SupplierRawMaterialCommercialDetails
    },
    data () {
      return {
        activeTab: 0,
        id: null,
        status: {},
        index: null,
        isComplete: true,
        rm_details: {},
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      async notify() {
        this.activeTab++
        await this.getStatus()
      },
      async checkStepFactory() {
        return Object.entries(this.status).forEach(([key, value], index) => {
          if (value === 0) {
            console.log(index)
            return index--
          }
        });
      },
      async onClickSubmitRawMaterial(){
        this.$vs.loading()
        try {
          const data = (await SupplierRawMaterialRepository.submitRawMaterial(this.id))
          this.showSuccessMessage('Raw material submit successfully');
          location.reload();
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getStatus() {
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status = data
        for (let k in this.status) {
          if (data.hasOwnProperty(k)) {
            console.log(this.status[k])
            if (this.status[k] === false) {
              this.isComplete = false
            }
          }
        }
      },
      async getRmDetails() {
        try {
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialDetails(this.id)).data
          this.rm_details = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      if(this.$route.query.price_request) {
        this.activeTab = 22
      }
      await this.getStatus()
      await this.getRmDetails()
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
